import styled from '@emotion/styled'
import { metrics, ThemeMargins } from '../../__styling/settings/metrics'
import {
    breakpoint,
    breakpointBetween,
    breakpointMax,
} from '../../__styling/style-functions'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import {
    horizontalDividers,
    verticalDividers,
} from '../../__styling/style-mixins'
import { themedValue } from '../../__styling/themed-value'

export interface GridProps {
    verticalSpacing: keyof ThemeMargins | undefined
}

export const StyledUniform = styled('div')<GridProps>(
    ({ theme, verticalSpacing }) => [
        {
            display: 'grid',
            gridGap: theme.margins.gridGap,
            gridTemplateColumns: '1fr',
            position: 'relative',
            width: '100%',
            margin: '0 auto',
            marginBottom:
                verticalSpacing &&
                themedValue(theme, {
                    thewest: calcRem(theme.margins[verticalSpacing]),
                    fallback: undefined,
                }),

            [breakpoint('sm')]: {
                gridTemplateColumns: 'repeat(2, 1fr)',
            },

            [breakpoint('md')]: {
                gridTemplateColumns: 'repeat(4, 1fr)',
            },
        },
        // Dividers and borders for the west
        theme.kind === 'thewest' && {
            paddingBottom: metrics.thewest.margins.sm,
            borderBottom: `4px double ${theme.colors.borders.secondary}`,
        },
    ],
)
StyledUniform.displayName = 'StyledUniform'

export const StyledUniformCardcontainer = styled('div')(
    ({ theme }) => ({
        display: 'grid',
        gridGap: theme.margins.gridGap,
        gridTemplateColumns: '1fr',
    }),
    ({ theme }) => [
        // Dividers
        theme.kind === 'thewest' && {
            position: 'relative',

            // Horizontal Divider For stacked cards inside a column
            '& > *:not(:last-child)::before': {
                ...horizontalDividers,
                backgroundColor: theme.colors.borders.primary,
            },

            '@media screen and (min-width: 768px)': {
                ':not(:first-child)::after': {
                    ...verticalDividers,
                    backgroundColor: theme.colors.borders.primary,
                },
            },

            // Small devices for bottom of columns
            [breakpointMax('sm')]: {
                '&:not(:last-child)::before': {
                    ...horizontalDividers,
                    backgroundColor: theme.colors.borders.primary,
                },
            },

            [breakpointBetween('sm', 'md')]: {
                // Add horizontal dividers on the bottom of the first row of cards
                ':nth-child(-n + 2)::before': {
                    ...horizontalDividers,
                },

                // Remove Vertical Dividers so it wont appear above "Medium breakpoint"
                ':nth-child(2n + 1)::after': {
                    content: 'none',
                },
            },
        },

        theme.kind === 'sevennews' && {
            position: 'relative',
        },
    ],
)
StyledUniformCardcontainer.displayName = 'UniformCardContainer'

export const StyledHeader = styled('div')(({ theme }) => ({
    display: 'block',
    marginBottom: theme.margins.md,
}))
